angular.module("digitalLeasing.module")
  .component("docAggiuntiviSetContract", {
    templateUrl: "ng/components/digitalLeasing/contractSignature/documentiAggiuntiviSetContrattuale/documentiAggiuntiviSetContrattuale.view.html",
    bindings: {
      model: '<',
      snapshot: '<'
    },
    controllerAs: "docAggSetContractCtrl",
    controller: DocumentiAggiuntiviSetContrattuale
  })

function DocumentiAggiuntiviSetContrattuale(
  $uniService,
  $rootScope,
  $simulationService,
  FileUploader,
  $configService,
  $timeout,
  $financialApiService,
  $download
) {
  var self = this;

  self.$onInit = function () {
    self.$rootScope = $rootScope;
    self.loadingStatus = {
      uploading: false
    }
    self.visualProgBarDoc = [];
    self.supportModel = {
      dropdownDocDaRicevere: [],
      docSelezionato: null
    }
    self.restrictedShow = !$configService.getAppConfig().allFunctionalities.includes("CUSTOM_CTR_READ_ONLY")
    self.listOfFilesUpload = [];
    listDocUpdate()
    popolateDropdown()
  }

  var popolateDropdown = function () {
    self.disabledDropdown = true;
    $uniService.getDocCatalog()
      .then(function (response) {
        self.supportModel.dropdownDocDaRicevere = response.domainList;
        self.disabledDropdown = false;
      })
  }

  var listDocUpdate = function () {
    $simulationService.getCustomDocsCtr(self.model.leasingData.id)
      .then(function (response) {
        if (response.success) {
          self.listOfFilesUpload = response.documents;
        }
      })
  }

  self.dropdownChanged = function (value) {
    if (value && value.name && value.name.toUpperCase().trim() != 'BENE') {
      self.supportModel.numeroOrdine = null;
    } else if (value && value.name && value.name.toUpperCase().trim() != 'GARANZIA') {
      self.supportModel.numeroGaranzie = null;
    }
  }

  self.addDocument = function () {
    var tmp = {
      docNameLabel: self.supportModel.docSelezionato.description,
      cdDoc: self.supportModel.docSelezionato.value,
      downloadKey: "",
      ordine: self.supportModel.numeroOrdine,
      garanzia: self.supportModel.numeroGaranzie,
      id: ""

    }
    self.listOfFilesUpload.push(tmp);
    self.supportModel.docSelezionato = null;
    self.supportModel.numeroGaranzie = null;
    self.supportModel.numeroOrdine = null;

  }

  self.check = function (el) {
    el.isSelected = !el.isSelected;
  };

  self.downloadFile = function (file) {
    var input = {
      downloadKey: file.downloadKey
    }
    var url = "/uni/downloadDocDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  }



  /* inizio sezione uploader */
  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.singleFile = self.listOfFilesUpload[index];
  };

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    if (!self.isSplit) {
      var url =
        $configService.getAppConfig().url +
        "/uni/upload/service-infos/" +
        encodeURIComponent(self.model.leasingData.preventivo.anno) +
        "/" +
        encodeURIComponent(self.model.leasingData.preventivo.numero) +
        "/FINANCIAL-" +
        self.singleFile.codiceDocNSIL;
    }
    self.disabledForUploadingInProgress = true;
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    var filesUpload = document.querySelector(
      "#uploadInput_documentAggiuntivi_" + self.currentCodeTypeNameIndex
    ).files;
    filesUpload = Object.keys(filesUpload).map(function (key) {
      return filesUpload[key];
    });
    var formData = new FormData();

    jQuery("#uploadInput_documentAggiuntivi_" + self.currentCodeTypeNameIndex).val("");
    var ndgCliente = self.model.financialCustomer.metadata.riUserG.ndg
    filesUpload.forEach(function (file) {
      formData = new FormData();
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "FINANCIAL");
      appendToForm(formData, "cdDoc", self.listOfFilesUpload[self.currentCodeTypeNameIndex].cdDoc);
      appendToForm(formData, "ndgCliente", ndgCliente);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.model.leasingData.id);
      appendToForm(formData, "numeroAnno", self.model.leasingData.preventivo.anno);
      appendToForm(formData, "numeroContratto", self.model.leasingData.contratto.numero);
      appendToForm(formData, "modulo", self.model.leasingData.contratto.modulo);
      appendToForm(formData, "numeroPreventivo", self.model.leasingData.preventivo.numero);
      appendToForm(formData, "category", "CUSTOM_CTR");
      appendToForm(formData, "ordine", self.listOfFilesUpload[self.currentCodeTypeNameIndex].ordine);
      appendToForm(formData, "garanzia", self.listOfFilesUpload[self.currentCodeTypeNameIndex].garanzia);

      $financialApiService
        .uploadDocOnDigital(formData)
        .then(function (response) {
          if (response.success) {
            $timeout(function () {
              self.listOfFilesUpload[self.currentCodeTypeNameIndex].id = response.id;
              self.listOfFilesUpload[self.currentCodeTypeNameIndex].downloadKey = response.downloadKey;
              self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
              self.disabledForUploadingInProgress = false;
            }, 1);
          } else {
            self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
            self.disabledForUploadingInProgress = false;
          }
        })
        .catch(function (error) {
          self.disabledForUploadingInProgress = false;
          self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
        });
    });
  }
  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_documentAggiuntivi_" + self.currentCodeTypeNameIndex).val("");
    }
    var fileName = fileItem.file.name;
    //if ( ) {
    self.uploader.queue[0].progress = 100;

    self.visualProgBarDoc[self.currentCodeTypeNameIndex] = true;

    $timeout(function () {
      self.progresso = 100;
    }, 500);
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    jQuery("#uploadInput_documentAggiuntivi_" + self.currentCodeTypeNameIndex).val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;
    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
    }, 1);

    fileItem.remove();
    jQuery("#uploadInput_documentAggiuntivi_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

    }
    self.uploader.queue = [];

    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;

      self.disabledForUploadingInProgress = false;
    }, 1);
    jQuery("#uploadInput_documentAggiuntivi_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };


  /* fine sezione uploader */

  self.deletedFiles = function (index, deleteAll) {
    self.progresso = 100;

    self.visualProgBarDoc[index] = true;
    self.documentsToBeDeleted = [];


    self.documentsToBeDeleted.push(self.listOfFilesUpload[index]);

    var numberOfElementToDeleted = self.documentsToBeDeleted.length
    $timeout(function () {
      self.progresso = 0;
    }, (numberOfElementToDeleted * 400));
    self.documentsToBeDeleted.forEach(function (element) {
      $simulationService
        .deleteChecklistFileDigital(element.id)
        .then(function (response) {
          console.log(response);
          if (response.success) {
            $timeout(function () {
              self.listOfFilesUpload[index].downloadKey = ""

              self.uploadOk = false;
              if (deleteAll) {
                self.visualProgBarDoc[index] = false;
                self.listOfFilesUpload = self.listOfFilesUpload.filter(function (element, indice) {
                  return indice != index
                })
                refreshView();
              }
              self.visualProgBarDoc[index] = false;

            }, 1);
          } else {
            self.visualProgBarDoc[index] = false;
            self.uploadOk = false;
          }
        })
        .catch(function (error) {
          console.log(error)
        });
    });

  }

  self.genericTrashCheck = function (index) {
    return (
      self.listOfFilesUpload[index] &&
      self.listOfFilesUpload[index].uploadedFiles &&
      self.listOfFilesUpload[index].uploadedFiles.some(function (element) {
        return element.isSelected == true;
      })
    );
  };

  self.enableDisabledAddButton = function () {

    if (self.supportModel.docSelezionato && self.supportModel.docSelezionato.name) {

      switch (self.supportModel.docSelezionato.name.toUpperCase().trim()) {
        case 'BENE':
          return !!self.supportModel.numeroOrdine;
          break;

        case 'GARANZIA':
          return !!self.supportModel.numeroGaranzie;
          break;

        default:
          return true;
          break;
      }
    }
    return false;
  }

  self.removeAllFile = function (index) {
    if (self.listOfFilesUpload[index] && self.listOfFilesUpload[index].downloadKey) {
      self.deletedFiles(index, true)
    } else {
      self.listOfFilesUpload = self.listOfFilesUpload.filter(function (element, indice) {
        return indice != index
      })
      refreshView()
    }
  }

  var refreshView = function () {
    self.refreshWiewVariable = true;
    $timeout(function () {
      self.refreshWiewVariable = false;
    }, 150)
  }
}